import { RefillMain, OnChangeStep } from 'app/common/components/Finances/FinancesFund'
import {
  useAcquiringSettingsData,
  useAcquiringSettingsLoading,
} from 'app/dataProviders/acquiring/settings/hooks'
import { useDealerPhone } from 'app/dataProviders/dealer/hooks'
import { RefillStep, RefillTarget, RefillType } from 'app/dataTypes/acquiring/settings'

type Props = {
  cafeteriaOwnAccountRefillDisable: boolean
  payForAlerts: boolean
  showSuccess: boolean
  showFail: boolean
  refillStep: RefillStep | null
  refillTarget: RefillTarget | null
  refillType: RefillType | null
  targetID: string | null
  homeURL: string
  successURL: string
  failureURL: string
  hideReplenishChild?: boolean
  hideReplenishChildCamp?: boolean
  onChangeStep: OnChangeStep
}

export const Refill = ({
  cafeteriaOwnAccountRefillDisable,
  payForAlerts,
  showSuccess,
  showFail,
  refillStep,
  refillTarget,
  refillType,
  targetID,
  homeURL,
  successURL,
  failureURL,
  hideReplenishChild,
  hideReplenishChildCamp,
  onChangeStep,
}: Props) => {
  const acquiringSettings = useAcquiringSettingsData()
  const loading = useAcquiringSettingsLoading()
  const dealerPhone = useDealerPhone()

  return (
    <RefillMain
      acquiringSettings={acquiringSettings}
      loading={loading}
      cafeteriaOwnAccountRefillDisable={cafeteriaOwnAccountRefillDisable}
      payForAlerts={payForAlerts}
      showSuccess={showSuccess}
      showFail={showFail}
      helpPhone={dealerPhone}
      refillStep={refillStep}
      refillTarget={refillTarget}
      refillType={refillType}
      targetID={targetID}
      homeURL={homeURL}
      successURL={successURL}
      failureURL={failureURL}
      hideReplenishChild={hideReplenishChild}
      hideReplenishChildCamp={hideReplenishChildCamp}
      onChangeStep={onChangeStep}
    />
  )
}
